import React, { createContext, useState, useContext, useCallback } from 'react';
import QueueChatPauseService from '../components/Navbars/ServicePanel/LoginQueueChat/service/pause';
import QueueService from '../components/Navbars/ServicePanel/LoginQueueChat/service/queue';
import { toast } from 'react-toastify';
const QueuePauseChatContext = createContext();

export function QueueChatPauseProvider({ children }) {
  const [inQueueChatPause, setInQueueChatPause] = useState(false);
  const [currentQueueChatPause, setCurrentQueueChatPause] = useState({});
  const [typeOfPause, setTypeOfPause] = useState('');

  const [messageSendingBlocked, setMessageSendingBlocked] = useState(false);
  const [queuesChatLoggedValues, setQueueChatLoggedValues] = useState([]);
  const [currentPauseId, setCurrentPauseId] = useState('');
  const [queuesMap, setQueuesMap] = useState(new Map());
  const [dateOfStartChatPause, setDateOfStartPause] = useState('');

  const handleChangeTypeOfPause = (value) => {
    localStorage.setItem('type_of_pause', value);
    setTypeOfPause(() => localStorage.getItem('type_of_pause'));
  };

  const handleChangeStatusPauseChat = async (isPause, pauseId, pause) => {
    try {
      let result;
      if (isPause) {
        result = await QueueChatPauseService.pauseOn(pauseId);
      } else {
        result = await QueueChatPauseService.pauseOff();
        setCurrentQueueChatPause(null);
      }

      if (result?.data?.inPause) {
        setCurrentQueueChatPause(pause);
        if (pause && pause?.active) {
          setMessageSendingBlocked(false);
        } else {
          setMessageSendingBlocked(true);
        }
      } else {
        setMessageSendingBlocked(false);
      }

      setInQueueChatPause(result?.data.inPause);
      setCurrentPauseId(result?.data.currentPauseId);
      setDateOfStartPause(new Date(result?.data.dateOfPause));
    } catch (err) {
      toast.error(
        `Ocorreu um error ao tentar ${isPause ? 'pausar' : 'despausar'} o chat`
      );
    }
  };

  /**
   * @param {String[]} value
   */
  const handleLoginInTheQueuesChat = async (newQueues) => {
    const newQueuesResponse = await QueueChatPauseService.loginInNewQueues(
      newQueues
    );

    if (newQueuesResponse.isError) {
      toast.error(newQueuesResponse.message);
      return;
    }

    if (newQueuesResponse.inPause) {
      const { data } = await QueueChatPauseService.getAll();
      let pauseData;
      data.forEach((pause) => {
        if (pause.id === currentPauseId) {
          pauseData = pause;
        }
      });

      setCurrentQueueChatPause(pauseData);
      if (pauseData && pauseData?.active) {
        setMessageSendingBlocked(false);
      } else {
        setMessageSendingBlocked(true);
      }

      setInQueueChatPause(newQueuesResponse.inPause);
      setCurrentPauseId(newQueuesResponse.currentPauseId);
      setDateOfStartPause(new Date(newQueuesResponse.dateOfPause));

      toast.info(newQueuesResponse.message);
      return newQueuesResponse.queuesLogged;
    }

    if (!newQueuesResponse.isError) {
      toast.info(newQueuesResponse.message);
    }

    setQueueChatLoggedValues(newQueuesResponse.queuesLogged);

    return newQueuesResponse.queuesLogged;
  };

  const handleLogoutInTheQueuesChat = async (queuesToLogout) => {
    const newQueuesResponse = await QueueChatPauseService.logoutInQueues(
      queuesToLogout
    );

    setQueueChatLoggedValues(newQueuesResponse);
    return newQueuesResponse;
  };

  const getInitialValuesQueueChatPause = useCallback(async () => {
    const agentStatus = await QueueChatPauseService.getAgentStatusChat();
    await getAllQueues();
    const { data } = await QueueChatPauseService.getAll();

    const is_paused = agentStatus?.inPause || false;
    const type_of_pause = localStorage.getItem('type_of_pause');
    const queuesLogged = agentStatus?.queuesLogged || [];
    const currentPauseId = agentStatus?.currentPauseId || '';

    if (is_paused && currentPauseId) {
      data.forEach((pause) => {
        if (pause.id === currentPauseId) {
          setCurrentQueueChatPause(pause);
        }
      });
    }
    setInQueueChatPause(is_paused);
    setTypeOfPause(type_of_pause);
    setQueueChatLoggedValues(queuesLogged);
    setCurrentPauseId(currentPauseId);
    setDateOfStartPause(new Date(agentStatus?.dateOfPause));
  }, []);

  const getAllQueues = async () => {
    try {
      const response = await QueueService.getAll();

      const { data } = response?.data;

      const chatQueues = data.filter((q) => q?.is_chat);
      const queueMap = new Map();

      chatQueues.forEach((queue) => {
        queueMap.set(queue.id, queue);
      });

      setQueuesMap(queueMap);
      return chatQueues;
    } catch (err) {
      toast.error('Houve um erro ao buscar as filas');
    }
  };

  return (
    <>
      <QueuePauseChatContext.Provider
        value={{
          queues: queuesMap,
          inQueueChatPause,
          typeOfPause,
          getInitialValuesQueueChatPause,
          handleChangeStatusPauseChat,
          handleChangeTypeOfPause,
          handleLoginInTheQueuesChat,
          handleLogoutInTheQueuesChat,
          queuesChatLoggedValues,
          messageSendingBlocked,
          currentPauseId,
          dateOfStartChatPause,
          currentQueueChatPause,
          getAllQueues
        }}
      >
        {children}
      </QueuePauseChatContext.Provider>
    </>
  );
}

/**
 * @description Este hook é responsável por retornar o contexto de pausa do chat
 *  Responsável por maninupar o estado de pausa ede filas logadas do chat no menu superior
 * @returns {Object} Retorna o contexto de pausa do chat
 *
 */

export function useQueueChatPauseContext() {
  const context = useContext(QueuePauseChatContext);
  return context;
}
